import { render } from "./TeamManageListView.vue?vue&type=template&id=4a99b0f9"
import script from "./TeamManageListView.vue?vue&type=script&lang=js"
export * from "./TeamManageListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__